const HTML_TAG = /<[^>]+>/g;
const PARAGRAPH_END = /<\/p>/g;
const DIV_END = /<\/div>/g;
const BR = /<br ?\/?>/g;
const LIST_ITEM_END = /<\/li>/g;
const LIST_ITEM_START = /<li>/g;
const UNORDERED_LIST = /<ul.*?>(.*?)<\/ul>/g;
const ORDERED_LIST = /<ol.*?>(.*?)<\/ol>/g;
const NEWLINE_AT_END = /\s+$/;
const NEWLINE = '\n';
const HTML_AMPERSAND = /&amp;/g;
const PLAIN_AMPERSAND = '&';

export default str => {
  return str
    .replace(UNORDERED_LIST, (match, p1) => {
      return p1.replace(LIST_ITEM_START, ' - ');
    })
    .replace(ORDERED_LIST, (match, p1) => {
      let ordinal = 0;
      return p1.replace(LIST_ITEM_START, () => {
        ordinal += 1;
        return ` ${ordinal}. `;
      });
    })
    .replace(PARAGRAPH_END, NEWLINE)
    .replace(DIV_END, NEWLINE)
    .replace(BR, NEWLINE)
    .replace(LIST_ITEM_END, NEWLINE)
    .replace(HTML_TAG, '')
    .replace(NEWLINE_AT_END, '')
    .replace(HTML_AMPERSAND, PLAIN_AMPERSAND);
};
